import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class ScreenService implements OnDestroy {

  private _resize$: Observable<any>;

  constructor() {
    this._resize$ = fromEvent(window, 'resize');
  }


  resize$() {
    return this._resize$ ? this._resize$.pipe(share()) : null;
  }

  ngOnDestroy(): void {
    this._resize$ = null;
  }
}
